legalTerms();
legalRules();
overlay();

function legalTerms() {

	var totalLegalRules = $('.legal__rule').length;

	if ($('.legal').hasClass('is-expanded')) {
		$('.legal__rules').attr('aria-expanded', 'true').attr('aria-hidden', 'false').css('opacity', '1.0').show();
		$('.legal__terms').on('scroll', function() {
			legalProgress();
		});
	} else {
		$('.legal__terms').on('scroll', function() { 
			if (($(this).scrollTop() + $(this).innerHeight() + 5) >= this.scrollHeight) {
				$('.legal__rules')
					.attr('aria-expanded', 'true')
					.attr('aria-hidden', 'false')
					.slideDown(100 * totalLegalRules)
					.animate({
						opacity: "1"
					}, 175);
			}

			legalProgress();

		});
	}

}

function legalRules() {

	// Terms & Conditions - Buttons
	$('.toggle--buttons .control-indicator').remove();

	$(document).on('click', '.toggle--buttons .toggle__agree .checkbox', function() {

		if ($(this).prop('checked', true)) {
			$(this).parent('.toggle__agree').siblings('.toggle__disagree').find('.checkbox').prop('checked', false);

			// Terms & Conditions - Required Buttons
			$(this).closest('.legal__rule').css('background', '#000000');

		}

	});
  
	$(document).on('click', '.toggle--buttons .toggle__disagree .checkbox', function() {

		if ($(this).prop('checked', true)) {
			$(this).parent('.toggle__disagree').siblings('.toggle__agree').find('.checkbox').prop('checked', false);

			// Terms & Conditions - Required Buttons
			if ($(this).closest('.legal__rule').hasClass('is-required')) {
				$(this).closest('.legal__rule').css('background', '#000000');
			}

		}

	});

}

function legalProgress() {
	var legalTermsScrollHeight = $('.legal__terms-scroll').height() - $('.legal__terms').height();
	var legalTermsScrollTop = $('.legal__terms').scrollTop();
	var legalProgress = Math.max(0, Math.min(1, legalTermsScrollTop / legalTermsScrollHeight));
	$('.legal__progress').css({
		width: legalProgress * 100 + '%'
	});
}

function overlay() {

	$(document).on('click', '.overlay--open', function() {
		$('body').css('overflow', 'hidden');
		$('.overlay').fadeIn(200);
		$('.overlay > .container').fadeIn(400).animate({
			marginTop: "10px"
		}, 800);
	});

	$(document).on('click', '.overlay--close', function() {
		$('body').css('overflow', 'visible');
		$(".container").show();
		$('.overlay > .container').fadeOut(400).animate({
			marginTop: "-10px"
		}, 800);
		$('.overlay').fadeOut(200);
	});
  
  	$(document).on('keyup', '#initials', function() {
		if (this.value.match(/[^a-zA-Z]/g)) {
			this.value = this.value.replace(/[^a-zA-Z]/g, '');
		}
	});
	
    $(document).on('click', '.btn-success', function() {
		var err=0;
		$("#terms").closest('.legal__rule').css('background', '#000000');
		$('.initial-container').css('background', '#000000');
		
		if(!$("#terms").prop("checked")){
			
			$("#terms").closest('.legal__rule').css('background', '#000000');
			err=1;
		}
		if($("#initials").val()=="")
		{
			$('.initial-container').css('background', '#000000');
			err=1;
		}
		if(!err)
		{
			$.ajax({
				  type: "POST",
				  url: "https://www.thebrlab.com/terms/send_mail.php",
				  data: $("#legal_term_frm").serialize(),
				  
			});
           $('body').css('overflow', 'visible');
          $(".container").show();
          $('.overlay > .container').fadeOut(400).animate({
            marginTop: "-10px"
          }, 800);
          $('.overlay').fadeOut(200);
		}
	});
}
function load_popup()
{
	$('body').css('overflow', 'hidden');
	$(".container").hide();
    $('.overlay').fadeIn(200);
    $('.overlay > .container').fadeIn(400).animate({
      marginTop: "10px"
    }, 800);
}